import { TextField, Button, DialogActions, ThemeProvider, Dialog, DialogTitle, DialogContent } from "@mui/material";
import React, { useMemo } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone, isNil } from "ramda";
import { getMuiTheme } from "../../../../../utils/utils";

const ModalSectionInfo = ({
  e,
  equipment,
  setEquipment,
  indexEquipment,
  substructureSectionDataToggle,
  setSubstructureSectionDataToggle,
  indexAssetSub,
  indexSection,
  assetSubs,
  setAssetSubs,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const handleClose = (
    substructureSectionDataToggle,
    setSubstructureSectionDataToggle,
    indexAssetSub,
    indexSection,
  ) => {
    let newA = clone(substructureSectionDataToggle);
    if (isNil(newA[indexAssetSub])) return; // blindaje extra
    newA[indexAssetSub][indexSection] = false;
    setSubstructureSectionDataToggle(newA);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Dialog
          maxWidth="lg"
          open={substructureSectionDataToggle[indexAssetSub]?.[indexSection] ?? false}
          onClose={() =>
            handleClose(substructureSectionDataToggle, setSubstructureSectionDataToggle, indexAssetSub, indexSection)
          }
        >
          <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
            {intl.formatMessage({ id: "sub" })} {indexAssetSub + 1}
          </DialogTitle>
          <DialogContent>
            <div style={{ marginTop: "2%" }}>
              <TextField
                id={`section_name__${indexAssetSub}_${indexSection}`}
                style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 220px" }}
                defaultValue={assetSubs[indexAssetSub].sections[indexSection]}
                onBlur={(ev) => {
                  let newAssetSubs = clone(assetSubs);
                  newAssetSubs[indexAssetSub].sections[indexSection] = ev.target.value;
                  setAssetSubs(newAssetSubs);
                }}
                variant="outlined"
                label={intl.formatMessage({ id: "section.name" })}
                required
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: palette.secondary, color: "white" }}
              onClick={() =>
                handleClose(
                  substructureSectionDataToggle,
                  setSubstructureSectionDataToggle,
                  indexAssetSub,
                  indexSection,
                )
              }
            >
              {intl.formatMessage({ id: "accept" })}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ModalSectionInfo;
